module.exports = __webpack_public_path__ + "img/full-Pill-Blue-Glossy.2a8530e3.png";